import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Sparkles, Lock, TrendingUp, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface UpgradePromptProps {
  feature: string;
  description: string;
  variant?: 'card' | 'banner' | 'inline';
  className?: string;
}

export const UpgradePrompt = ({ 
  feature, 
  description, 
  variant = 'card',
  className = '' 
}: UpgradePromptProps) => {
  const navigate = useNavigate();

  if (variant === 'banner') {
    return (
      <div className={`bg-gradient-to-r from-primary/10 via-primary/5 to-transparent border-l-4 border-primary p-4 rounded-lg ${className}`}>
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Sparkles className="h-5 w-5 text-primary flex-shrink-0" />
            <div>
              <p className="font-semibold">{feature}</p>
              <p className="text-sm text-muted-foreground">{description}</p>
            </div>
          </div>
          <Button onClick={() => navigate('/newsletter')} size="sm">
            Upgrade
          </Button>
        </div>
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <div className={`flex items-center gap-2 text-sm text-muted-foreground ${className}`}>
        <Lock className="h-4 w-4" />
        <span>{description}</span>
        <Button 
          variant="link" 
          size="sm" 
          className="h-auto p-0"
          onClick={() => navigate('/newsletter')}
        >
          Upgrade →
        </Button>
      </div>
    );
  }

  return (
    <Card className={`p-6 text-center space-y-4 ${className}`}>
      <div className="flex justify-center">
        <div className="rounded-full bg-primary/10 p-3">
          <Sparkles className="h-6 w-6 text-primary" />
        </div>
      </div>
      <div className="space-y-2">
        <h3 className="text-lg font-semibold">{feature}</h3>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      <Button onClick={() => navigate('/newsletter')} className="w-full">
        <Sparkles className="mr-2 h-4 w-4" />
        Upgrade to Premium
      </Button>
      <div className="grid grid-cols-3 gap-4 pt-4 border-t text-xs text-muted-foreground">
        <div className="flex flex-col items-center gap-1">
          <TrendingUp className="h-4 w-4" />
          <span>Personalized Feed</span>
        </div>
        <div className="flex flex-col items-center gap-1">
          <Zap className="h-4 w-4" />
          <span>Deep Dives</span>
        </div>
        <div className="flex flex-col items-center gap-1">
          <Sparkles className="h-4 w-4" />
          <span>Weekly Newsletter</span>
        </div>
      </div>
    </Card>
  );
};
